<div class="row px-4 pt-2 pb-4">
  <aquamore-free-ticket-element class="col-12" [mainProductId]="idProduct" (updated)="loadRelated()"></aquamore-free-ticket-element>
  <aquamore-free-ticket-element class="col-12 pt-4" [mainProductId]="idProduct" (updated)="loadRelated()" *ngFor="let product of relatedProducts" [relatedProduct]="product"></aquamore-free-ticket-element>
</div>